import {ENDPOINT_WORKFLOW_TASK, ENDPOINT_WORKFLOW} from 'common/endpoints';
import _ from 'lodash';
import {commonJwtHeader} from 'common/utils';

// TODO, fix so permissions aren't passed in, but read from token.
const getAllExternalEligibleTasks = (token, extraCols, body, maxResults) => {
  return fetch(
    `${ENDPOINT_WORKFLOW_TASK}external?maxResults=${maxResults ? maxResults : 50}${
      extraCols ? '&extraCols=' + extraCols.join(',') : ''
    }`,
    {
      method: 'POST',
      headers: commonJwtHeader(),
      body: JSON.stringify(body),
    }
  );
};

// gets extremely limited info for all entities this user has permissions for (id + name essentially)
const getVariableValuesForTask = (token, taskDefKey, variable, processDefKey) => {
  let endpointQueryVar =
    processDefKey != undefined ? `&processDefKey=${processDefKey}` : '';
  return fetch(
    `${ENDPOINT_WORKFLOW_TASK}distinct-variables/?taskDefKey=${taskDefKey}&variableName=${variable}${endpointQueryVar}`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

const getAssignedTo = (token, queryString = '') => {
  return fetch(`${ENDPOINT_WORKFLOW_TASK}assignees${queryString}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getTasksWithVariables = (token, body, variables, pageSize, firstResult) => {
  return fetch(
    `${ENDPOINT_WORKFLOW_TASK}?extraCols=${_.join(
      variables,
      ','
    )}&maxResults=${pageSize}&firstResult=${firstResult}&withCandidateGroups=true`,
    {
      method: 'POST',
      headers: commonJwtHeader(),
      body: JSON.stringify(body),
    }
  );
};

const getTasksForGrant = (token, grantId) => {
  return fetch(
    `${ENDPOINT_WORKFLOW_TASK}?processVariables=grantId_eq_${grantId}&withCandidateGroups=true&withProcessDefinitionKey=true&includeAssignedTasks=true&extraCols=subGrantId,excludedPerformer`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

const getTasksForSubGrant = (token, subGrantId) => {
  return fetch(
    `${ENDPOINT_WORKFLOW_TASK}?processVariables=subGrantId_eq_${subGrantId}&withCandidateGroups=true&withProcessDefinitionKey=true&includeAssignedTasks=true&extraCols=subGrantId,excludedPerformer`,
    {
      method: 'GET',
      headers: commonJwtHeader(),
    }
  );
};

const getTaskCount = (token, body) => {
  return fetch(`${ENDPOINT_WORKFLOW_TASK}count`, {
    method: 'POST',
    headers: commonJwtHeader(),
    body: JSON.stringify(body),
  });
};

const bulkVariableUpdate = (token, body) => {
  return fetch(`${ENDPOINT_WORKFLOW}bulk-tasks`, {
    method: 'POST',
    headers: commonJwtHeader(),
    body: JSON.stringify(body),
  });
};

const bulkComplete = (token, taskIds, payload) => {
  const payloadKey = 'payload';

  return fetch(`${ENDPOINT_WORKFLOW}bulk-tasks/complete`, {
    method: 'PUT',
    headers: commonJwtHeader(),
    body: JSON.stringify({
      taskIds: taskIds,
      [payloadKey]: payload,
    }),
  });
};

const startProcess = (
  token,
  processDefinitionKey,
  password,
  topLevelParameters,
  startingVariables
) => {
  var headers = commonJwtHeader();
  headers['x-taskauth-password'] = password;
  return fetch(
    `${ENDPOINT_WORKFLOW}process-definitions/${processDefinitionKey}/processes`,
    {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        ...topLevelParameters,
        variables: startingVariables,
      }),
    }
  );
};

const startsubApplicationProcess = (
  token,
  processDefinitionKey,
  topLevelParameters,
  startingVariables
) => {
  return fetch(
    `${ENDPOINT_WORKFLOW}process-definitions/${processDefinitionKey}/processes`,
    {
      method: 'POST',
      headers: commonJwtHeader(),
      body: JSON.stringify({
        ...topLevelParameters,
        variables: startingVariables,
      }),
    }
  );
};

const sendSignal = (token, data, signalName) => {
  return fetch(`${ENDPOINT_WORKFLOW}grant-signals/${signalName}`, {
    method: 'PUT',
    headers: commonJwtHeader(),
    body: JSON.stringify(data),
  });
};
const sendSignalForSubGrant = (token, data, signalName) => {
  return fetch(`${ENDPOINT_WORKFLOW}grant-signals/${signalName}`, {
    method: 'PUT',
    headers: commonJwtHeader(),
    body: JSON.stringify(data),
  });
};
const sendMessage = (activityId, body) => {
  return fetch(`${ENDPOINT_WORKFLOW}messages/${activityId}`, {
    method: 'POST',
    headers: commonJwtHeader(),
    body: JSON.stringify(body),
  });
};
const checkProcessInstanceStatus = (token, processInstanceId) => {
  return fetch(`${ENDPOINT_WORKFLOW}process-instances/${processInstanceId}/status`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const checkActivityStatus = (
  token,
  processInstanceId,
  activityId,
  activityMaxCount = null
) => {
  let url = `${ENDPOINT_WORKFLOW}process-instances/${processInstanceId}/activities/${activityId}/status`;

  if (activityMaxCount) {
    url = `${ENDPOINT_WORKFLOW}process-instances/${processInstanceId}/activities/${activityId}/status?maxActivityNumber=${activityMaxCount}`;
  }

  return fetch(url, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getAvailableTaskNames = (token) => {
  return fetch(`${ENDPOINT_WORKFLOW_TASK}names`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getTaskSummary = (token) => {
  return fetch(`${ENDPOINT_WORKFLOW_TASK}summaries`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getHistoricTasks = (
  token,
  taskAssignee,
  firstResult,
  pageSize,
  extraCols,
  processDefinitionKey,
  sessionId
) => {
  return fetch(
    `${ENDPOINT_WORKFLOW}history/tasks?maxResults=${pageSize}&firstResult=${firstResult}&extraCols=${_.join(
      extraCols,
      ','
    )}`,
    {
      method: 'POST',
      headers: commonJwtHeader(),
      body: JSON.stringify({
        processDefinitionKey: processDefinitionKey,
        taskAssignee: taskAssignee,
        processVariables: [
          {
            name: 'sessionId',
            value: _.parseInt(sessionId),
            operator: 'eq',
          },
        ],
      }),
    }
  );
};

const getHistoricTasksCount = (
  token,
  taskAssignee,
  firstResult,
  pageSize,
  extraCols,
  processDefinitionKey,
  sessionId
) => {
  return fetch(
    `${ENDPOINT_WORKFLOW}history/tasks/count?maxResults=${pageSize}&firstResult=${firstResult}&extraCols=${_.join(
      extraCols,
      ','
    )}`,
    {
      method: 'POST',
      headers: commonJwtHeader(),
      body: JSON.stringify({
        processDefinitionKey: processDefinitionKey,
        taskAssignee: taskAssignee,
        processVariables: [
          {
            name: 'sessionId',
            value: _.parseInt(sessionId),
            operator: 'eq',
          },
        ],
      }),
    }
  );
};

const getWorkflowTask = ({taskId}) => {
  return fetch(`${ENDPOINT_WORKFLOW_TASK}${taskId}`, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const unassignAndExcludeAssignee = (body) => {
  return fetch(`${ENDPOINT_WORKFLOW_TASK}${body.taskId}/assignments`, {
    method: 'PUT',
    headers: commonJwtHeader(),
  });
};

export default {
  getVariableValuesForTask,
  getAssignedTo,
  getTasksWithVariables,
  getTasksForGrant,
  getTasksForSubGrant,
  getTaskCount,
  getAllExternalEligibleTasks,
  bulkVariableUpdate,
  bulkComplete,
  startProcess,
  startsubApplicationProcess,
  sendSignal,
  sendSignalForSubGrant,
  sendMessage,
  checkProcessInstanceStatus,
  checkActivityStatus,
  getAvailableTaskNames,
  getTaskSummary,
  getHistoricTasks,
  getHistoricTasksCount,
  getWorkflowTask,
  unassignAndExcludeAssignee,
};
